var app = new Vue({
  el: '#quiz-app',
  data() {
    return {
      currentQuestionIndex: 0,
      isSending: false,
      isComplete: false,
      notApplicable: false,
      answeringFor: 'Me',
      storageKey: 'quizResults',
      answers: {},
      email: '',
      quiz_marketing: ['true'],
      hasEmail: false,
      hasClass: false,
      questions: [
        {
          id: 'What_is_your_age',
          title: 'What is your age?',
          inputName: 'age',
          type: 'radio',
          answers: [
            '21–30',
            '31–45', 
            '46–60',
            'Over 60'
          ]
        },
        {
          id: 'What_are_you_looking_to_improve',
          title: 'What are you looking to improve?',
          inputName: 'improvement_goals', 
          type: 'checkbox',
          answers: [
            'Gaining an erection',
            'Maintaining an erection',
            'Premature ejaculation',
            'Erection quality (strength)',
            'Erection size',
            'Other/Not sure'
          ]
        },
        {
          id: 'Do_you_currently_have_any_conditions',
          title: 'Do you currently have any of the following conditions?',
          inputName: 'medical_conditions',
          type: 'checkbox',
          answers: [
            'Diabetes',
            'Cardiovascular disease',
            'Hypertension',
            'None'
          ]
        },
        {
          id: 'Have_you_had_any_surgeries',
          title: 'Have you had any of the following surgeries or procedures?',
          inputName: 'surgeries',
          type: 'checkbox', 
          answers: [
            'Prostate surgery',
            'Pelvic surgery',
            'Penile implant',
            'None'
          ]
        },
        {
          id: 'Do_you_take_any_medications',
          title: 'Do you currently take any of the following medications?',
          inputName: 'medications',
          type: 'checkbox',
          answers: [
            'Blood thinners',
            'Sildenafil (Viagra)',
            'Tadalafil (Cialis)',
            'None'
          ]
        },
        {
          id: 'Have_you_used_vacuum_therapy',
          title: 'Have you used a vacuum therapy device before?',
          inputName: 'vacuum_therapy_experience',
          type: 'radio',
          answers: [
            'Yes, I currently use one',
            'I\'ve tried one but stopped',
            'Never used one'
          ]
        },
        {
          id: 'Have_you_tried_other_ED_aids',
          title: 'Have you tried other ED aids that didn\'t work for you?',
          inputName: 'previous_ED_aids',
          type: 'radio',
          answers: [
            'Yes, and I wasn\'t satisfied',
            'No, I haven\'t tried anything else',
            'I\'ve tried some and had limited success'
          ]
        }
      ],
    }
  },
  mounted() {
    const previousResults = window.localStorage.getItem(this.storageKey) 
      ? JSON.parse(window.localStorage.getItem(this.storageKey)) 
      : null;
  
    if (previousResults && previousResults.hasOwnProperty('answers')) {
      this.answers = previousResults.answers;
      this.notApplicable = previousResults.notApplicable;
      this.isComplete = true;
      this.currentQuestionIndex = this.filteredQuestions.length + 1;
      
      this.email = previousResults.answers['What-s_your_email_address'] 
        ? previousResults.answers['What-s_your_email_address'].value 
        : '';
      this.hasEmail = !!this.email;
    }
  },
  computed: {
    filteredQuestions() {
      return this.questions;
    },
    currentQuestion() {
      var CurrentQtn = this.filteredQuestions[this.currentQuestionIndex - 1];
      if (typeof CurrentQtn !== 'undefined') {
        if (CurrentQtn.id == 'Whats_your_email-address') {
          this.hasClass = true;
        }
      }
      return this.filteredQuestions[this.currentQuestionIndex - 1];
    },
    readyForNextStep() {
      if (this.currentQuestion) {
        // For checkbox questions, require at least one selection
        if (this.currentQuestion.type === 'checkbox') {
          return this.answers[this.currentQuestion.inputName]?.value?.length > 0;
        }
        // For radio questions, just check if answer exists
        return Object.keys(this.answers).includes(this.currentQuestion.inputName);
      }
      return false;
    },
    isLastStep() {
      return this.currentQuestionIndex === this.filteredQuestions.length;
    },
    progressPercentageStyle() {
      return `width: ${Math.round((this.currentQuestionIndex - 1) / this.filteredQuestions.length * 100)}%`;
    }
  },
  methods: {
    checkDisqualifiers() {
      const conditions = this.answers.medical_conditions?.value || [];
      const surgeries = this.answers.surgeries?.value || [];
      const meds = this.answers.medications?.value || [];
      
      const disqualifiers = [
        'Diabetes',
        'Cardiovascular disease',
        'Hypertension',
        'Penile implant',
        'Blood thinners'
      ];
      
      return [
        ...conditions,
        ...surgeries,
        ...meds
      ].some(answer => disqualifiers.includes(answer));
    },
    async goToNextStep() {
      // On last step, check for disqualifiers before showing results
      if (this.isLastStep) {
        this.notApplicable = this.checkDisqualifiers();
        this.showResults();
      } else {
        this.currentQuestionIndex++;
      }
    },
    showResults() {
      document.querySelectorAll('input').forEach(input => input.checked = false);
      this.isSending = true;
      this.currentQuestionIndex++;
      
      window.localStorage.setItem(this.storageKey, JSON.stringify({
        answers: this.answers,
        notApplicable: this.notApplicable
      }));

      setTimeout(() => {
        this.isSending = false;
        this.isComplete = true;
        this.currentQuestionIndex++;

        // ADD THIS BLOCK
        // Wait for the DOM to update, then scroll the results page to the top.
        this.$nextTick(() => {
          if (this.$refs.resultsPage) {
            this.$refs.resultsPage.scrollTop = 0;
          }
        });
        // END OF ADDED BLOCK

      }, 2000);
    },
    selectAnswer(input, question) {
      const { value } = input;
      if (question.type === 'checkbox') {
        // Handle checkbox answers (multiple selections)
        const currentAnswers = this.answers[question.inputName]?.value || [];
        let newAnswers;
        
        if (currentAnswers.includes(value)) {
          newAnswers = currentAnswers.filter(v => v !== value);
        } else {
          newAnswers = [...currentAnswers, value];
        }
        
        this.$set(this.answers, question.inputName, { 
          value: newAnswers, 
          label: question.title 
        });
      } else {
        // Handle radio/other answers (single selection)
        this.$set(this.answers, question.inputName, { 
          value, 
          label: question.title 
        });
      }
    },
    selectAnswerChkbox(input, question) {
      const { value } = input;
      // Handle marketing checkbox
      if (input.checked) {
        this.quiz_marketing = ['true'];
      } else {
        this.quiz_marketing = [];
      }
    },
    goToPrevStep() {
      this.currentQuestionIndex--;
    },
    resetForm() {
      this.answers = {};
      this.currentQuestionIndex = 1;
      this.isComplete = false;
      this.notApplicable = false;
      this.email = '';
      this.hasEmail = false;
      this.quiz_marketing = []; 
      window.localStorage.removeItem(this.storageKey);
    },
    async submitEmail() {
      if (this.email) {
        this.isSending = true;
        const data = new URLSearchParams();
    
        // Append all answers to the data object
        Object.keys(this.answers).forEach((answerKey) => {
          const answerValue = this.answers[answerKey].value;
          if (Array.isArray(answerValue)) {
            answerValue.forEach(val => data.append(answerKey, val));
          } else {
            data.append(answerKey, answerValue);
          }
        });
    
        // Append email and marketing opt-in
        data.append('What-s_your_email_address', this.email);
        data.append('quiz_marketing', this.quiz_marketing.length ? 'true' : 'false');
    
        // Determine and append recommended product result
        const recomendedProd = this.notApplicable ? 'VaxAid Trainer' : 'VaxAid Deluxe';
        data.append('result', recomendedProd);
    
        try {
          const result = await fetch('https://hub.vaxaid.com/sandbox/vaxaid-klaviyo/response_handler.php', {
            method: 'POST',
            body: data,
          });
    
          this.hasEmail = true;
          await this.$nextTick();
        } catch (error) {
          console.error('Error sending email:', error);
        } finally {
          this.isSending = false;
        }
      }
    },
    getQuestionClass(question) {
      return question.type === 'checkbox' ? 'checkbox-question' : 'radio-question';
    }
  },
  delimiters: ['${', '}'],
});